// ============================================================================
// pushPrimingBus (W7-B, E12 / Karte C §Empfehlung d).
// ----------------------------------------------------------------------------
// Winziger Modul-Bus nach dem Vorbild von `auth/sessionEvents.ts` bzw.
// `app/bootSplashSignal.ts`. Er verbindet die Stellen, an denen ein Ereignis
// WIRKLICH passiert (die erste Nachricht des Begleiters, „Abenteuer ist
// bereit"), mit dem einen Ort, der den Berechtigungs-Dialog zeigt
// (StartupGateCoordinator).
//
// Bewusst kein React-Context: die Ausloeser sitzen tief in Chat-Seiten, die
// den Dialog nicht kennen sollen — und der Dialog haengt an einer ganz anderen
// Stelle im Baum. Ein Modul-Bus ist die kleinste Kopplung, die beides schafft.
//
// Der Bus kennt KEINE Regeln. Alle harten Grenzen (isStartupPushPromptDone,
// isProactivePushEnabled, einmal je Sitzung) liegen beim Empfaenger — sonst
// muesste jeder Ausloeser sie kennen und koennte sie vergessen.
// ============================================================================

/**
 * Warum gefragt wird. Der Grund entscheidet ueber den Text im Dialog
 * (push_priming.reason.*); 'fallback' bleibt beim allgemeinen
 * `startup.push.body`.
 */
export type PushPrimingReason =
  | 'companion_wants_to_write'
  | 'adventure_ready'
  // W2-B/F-01: die Vorplanung eines selbst gebauten Abenteuers BEGINNT (bis zu
  // zehn Minuten). Wer waehrend der Wartezeit geht, wurde bisher nie gefragt —
  // 'adventure_ready' kommt erst, wenn das Planungs-Overlay schliesst.
  | 'adventure_planning'
  | 'settings'
  | 'fallback';

type PushPrimingListener = (reason: PushPrimingReason) => void;

const listeners = new Set<PushPrimingListener>();

/**
 * Bittet um den Push-Priming-Dialog. Fire-and-forget: ob er wirklich erscheint,
 * entscheidet allein der Empfaenger. Ein Fehler in einem Zuhoerer darf den
 * Ausloeser (z.B. das Absenden einer Nachricht) niemals mitreissen.
 */
export function requestPushPriming(reason: PushPrimingReason): void {
  listeners.forEach((listener) => {
    try {
      listener(reason);
    } catch {
      /* Ein defekter Zuhoerer darf den Ausloeser nicht beschaedigen. */
    }
  });
}

/** Meldet einen Zuhoerer an. Rueckgabe = Abmeldung (fuer useEffect-Cleanup). */
export function onPushPrimingRequest(callback: PushPrimingListener): () => void {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

/** Nur fuer Tests: alle Zuhoerer entfernen. */
export function resetPushPrimingBus(): void {
  listeners.clear();
}
